import { render, staticRenderFns } from "./Page-Inventory.vue?vue&type=template&id=7f87fc0b"
import script from "./Page-Inventory.vue?vue&type=script&lang=js"
export * from "./Page-Inventory.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports